<div class="apg-card" [class.expanded]="this.expanded" [class.previewed]="this.previewed"
     data-element="snippet-card">

  <!-- Header: two rows, always visible (collapsed AND expanded). Click toggles. No chevron, and no
       header/body divider — the card flows seamlessly like the Hedge CoPilot solution-card. -->
  <div class="card-header" data-element="card-header" (click)="this.toggleExpanded()">

    <!-- The score badge was REMOVED on the owner's ruling O42 (2026-09-04): with the 50% price rule
         reverted there is no ranking behind a number, so it said nothing. He re-scores once the price
         rules are settled. The .score* styles are left in place, untouched, for that. -->

    <div class="card-main">
      <div class="hrow hrow-top">
        <span class="card-title" data-element="adjustment-title">{{ this.cardNumber }}</span>
        <span class="cost" [class.credit]="this.isCredit" [class.debit]="!this.isCredit"
              data-element="adjustment-cost">{{ this.costText }}</span>
      </div>
      <div class="hrow hrow-bottom">
        <span class="card-breadcrumbs" data-element="card-breadcrumbs">
          <span data-element="adjustment-type-label">{{ this.typeLabel }}</span>
          <span class="dot"> · </span>
          <span data-element="strike-path">{{ this.strikePath }}</span>
        </span>
        <span class="card-date" data-element="adjustment-date">{{ this.dateText }}</span>
      </div>

      <!-- Row 3, right-only: spread offset (orange) · spread width (blue), surfaced from the SAME
           CashFlowAdjustment fields the Price Box shows. Always on (independent of the Price Box
           "visible offsets" toggles). Hover shows a short label. Hidden when the cell has no offset data. -->
      <div class="hrow hrow-offsets" *ngIf="this.hasOffsets" data-element="card-offsets-row">
        <span class="card-offsets" data-element="card-offsets">
          <span *ngIf="this.spreadOffsetText" class="offset-code" title="Spread Offset (Calls/Puts)"
                data-element="spread-offset">{{ this.spreadOffsetText }}</span>
          <span *ngIf="this.spreadOffsetText && this.spreadWidthText" class="dot"> · </span>
          <span *ngIf="this.spreadWidthText" class="width-code" title="Spread Width (Calls/Puts)"
                data-element="spread-width">{{ this.spreadWidthText }}</span>
        </span>
      </div>
    </div>
  </div>

  <div class="card-body" *ngIf="this.expanded">

    <!-- Description flows right under the header as the natural separator (Hedge CoPilot parity). -->
    <div class="card-summary" data-element="card-summary">
      <p>{{ this.reasonText }}</p>
    </div>

    <!-- Attribute / Value table (mirrors the Hedge CoPilot card table). -->
    <table class="details" data-element="card-details">
      <thead>
        <tr><th>Attribute</th><th>Value</th></tr>
      </thead>
      <tbody>
        <tr data-element="detail-adjustment-type">
          <td>Adjustment Type</td><td>{{ this.typeLabel }}</td>
        </tr>
        <tr data-element="detail-destination-strike">
          <td>Destination Strike</td><td>{{ this.strikePath }}</td>
        </tr>
        <tr data-element="detail-expiration">
          <td>Expiration</td><td>{{ this.expirationText }}</td>
        </tr>
        <tr data-element="detail-template">
          <td>Template</td><td>{{ this.suggestion.content.template }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Half-width divider between the body and the action buttons. -->
    <div class="card-divider" data-element="card-divider"></div>

    <div class="card-actions" data-element="card-actions">
      <dx-button [text]="this.previewLabel" data-element="btn-preview"
                 (onClick)="this.onPreview()" width="100%"></dx-button>
      <dx-button text="Review" data-element="btn-review"
                 (onClick)="this.onReview()" width="100%"></dx-button>
    </div>

    <!-- M8 (CR-20260720-001): compliance disclaimer, under the action row so it is on screen before
         the adjustment is previewed. Expanded-body only — deliberately absent from the collapsed
         face (owner ruling). Text is the SHARED constant (copilot-shared/copilot-disclaimer.ts) —
         one source of truth for all five Co-Pilot render sites. -->
    <div class="card-disclaimer" data-element="card-disclaimer" *ngIf="this.disclaimerEnabled"><span class="disclaimer-label">{{ this.disclaimer.label }}</span>: {{ this.disclaimer.text }}</div>
  </div>
</div>
